import { render } from "./Table-Simple.vue?vue&type=template&id=4fc3e853&scoped=true"
import script from "./Table-Simple.vue?vue&type=script&lang=js"
export * from "./Table-Simple.vue?vue&type=script&lang=js"

import "./Table-Simple.vue?vue&type=style&index=0&id=4fc3e853&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc3e853"]])

export default __exports__